<template>
  <div class="row">
    <div class="col-sm-12">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 required">
            <label for="account_id">Account:</label>
            <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
          </div>
          <div class="form-group col-sm-12 col-md-6 required">
            <label for="from_date">From Date:</label>
            <input class="form-control" required type="date" v-model="from_date">
          </div>
          <div class="form-group col-sm-12 col-md-6 required">
            <label for="to_date">To Date:</label>
            <input class="form-control" type="date" v-model="to_date">
          </div>
          <div class="form-group col-sm-12">
            <input class="btn btn-primary" required type="submit" value="Show" :disabled="this.onRequest">
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <Datatable v-bind:entries="costs" :columns="columns" :currEntries="50" :title="'Cost User'"/>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import { getCapability } from '../_helpers'
  import Datatable from '../components/Datatable.vue'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
      ...mapState('costs', ['costs', 'onRequest']),
      ...mapState('accounts', ['accounts']),
      ...mapState('users', ['user']),
      columns(){
        return [
            {name: 'cost_date', text: 'Date', order: 'desc', raw:{type:'Moment_date'}},
            {name: 'code', text: 'Code'},
            {name: 'total_cost', text: 'Total', class: 'text-right',
              raw: {
                type: 'format_number'
              }
            },
            {name: 'account', text: 'Account',
              raw: {
                type: 'Sub',
                value: 'account_name'
              }
            },
            {name: 'vehicle', text: 'Vehicle',
              raw: {
                type: 'Sub',
                value: 'vehicle_no'
              }
            },
            {name: 'driver', text: 'Driver',
              raw: {
                type: 'Sub',
                value: 'name'
              }
            },
            {name: 'note', text: 'Note'},
            {name: 'status', text: 'Status',
              raw: {
                type: 'Text',
                fields: [
                  {value: '0', text: 'Need Approval'},
                  {value: '1', text: 'Approved'},
                  {value: '2', text: 'Paid'},
                ]
              }
            },
            {name: 'action', text: 'Action',
              raw: {
                type: 'Action',
                fields: [
                  (getCapability('edit_cost', this.user) || getCapability('approve_cost', this.user) || getCapability('set_paid_cost', this.user)) ? {event: 'edit_cost', text: 'Edit', method: 'get', class: 'btn btn-primary'} : {},
                  getCapability('delete_cost', this.user) ? {event: 'costs/destroy', text: 'Delete', method: 'post', class: 'btn btn-danger ml-1'} : {},
                  {event: 'print_cost', text: 'Print', method: 'print-cost', class: 'btn btn-info ml-1'},
                ]
              }
            },
          ]
        }
    },
    data(){
      return {
        account_id: null,
        accountOptions: [],
        from_date: moment().format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
      }
    },
    components:{
      Datatable,
      Select2,
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        const {account_id, from_date, to_date} = this
        this.get_cost_by_account({account_id, from_date, to_date})
      },
      ...mapActions('costs', ['get_cost_by_account']),
      ...mapActions('accounts', ['get_all']),
      ...mapActions('alert', ['error', 'clear']),
    },
    created() {
      this.$emit('onChildInit', 'Costs', getCapability('add_cost', this.user) ? '/costs/add' : '')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
            if(this.accountOptions.length > 0){
              this.account_id = this.accountOptions[0].id
              this.handleSubmit()
            }
          }
          return
        }
      },
    }
  }
</script>
